module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-main-a25872d5d99591deed4a596097585324.svg";